import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ArbreComposant,
  ArbreExplorer,
} from 'src/app/model/arbre/arbre-composant';
import { TreeType } from 'src/app/model/arbre/arbre-type';
import {
  APIUrls,
  WebConfigurationService,
} from '../common/web-configuration.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class TreeService extends WebConfigurationService {
  recordGuide(
    numSerie: string,
    resolved: boolean,
    dateHeure: string,
    username: string,
    exploredPaths: ArbreExplorer[],
    additionnalInfos: any[]
  ) {
    //, computedTree: MergeTree[]) {

    console.log('Ici record data');
  }

  private tree!: ArbreComposant[];
  private currentSelection: ArbreComposant[] = [];

  constructor(protected http: HttpClient, private userService: UserService) {
    super(http);
  }

  public fullTree(): ArbreComposant[] {
    return this.tree;
  }

  getLoadedComposant(id: number): ArbreComposant {
    let composant: any = this.tree.find((elt) => {
      return elt.id == id;
    });

    return composant as ArbreComposant;
  }

  /**
   * @Unused
   */
  public getTree(): Promise<ArbreComposant[]> {
    return this.authGetObs<ArbreComposant[]>(APIUrls.getTreeUrl()).toPromise();
  }

  /**
   * Get a promise resolving in an ArbreComposant by its id
   * @param id the id of the component to retrieve
   * @returns
   */
  public getComposant(id: number): Promise<ArbreComposant> {
    return this.authGetObs<ArbreComposant>(
      this.getTreeElementUrl(id.toString())
    ).toPromise();
  }

  getPotentialParents(type: string): Promise<ArbreComposant[]> {
    return this.authGetObs<ArbreComposant[]>(
      this.getTreeElementsByChildrenTypeUrl(type)
    ).toPromise();
  }

  getPotentialChildren(type: string): Promise<ArbreComposant[]> {
    return this.authGetObs<ArbreComposant[]>(
      this.getTreeElementsByTypeUrl(type)
    ).toPromise();
  }

  getChildren(composant: ArbreComposant): Promise<ArbreComposant[]> {
    return this.authGetObs<ArbreComposant[]>(
      this.getTreeChildrenUrl(composant.id.toString())
    ).toPromise();
  }

  getComposantsByIds(ids: string[]): Observable<ArbreComposant[]> {
    return this.authGetObs<ArbreComposant[]>(this.getTreeComposantsUrl(ids));
  }

  getTreeTypes(): Observable<TreeType[]> {
    return this.authGetObs<TreeType[]>(this.getTreeTypesUrl());
  }

  getPotentialChildrenByType(type: string) {
    return this.tree.filter((elt) => {
      return elt.type == type;
    });
  }

  getParentsByType(typeToShow: string): ArbreComposant[] {
    return this.tree.filter((elt) => {
      return elt.children_type == typeToShow;
    });
  }

  addComposantToSelection(composant: ArbreComposant) {
    this.currentSelection.push(composant);
  }

  getCurentSelection(): ArbreComposant[] {
    return this.currentSelection;
  }

  resetSubTree() {
    this.currentSelection = [];
  }

  deleteElement(id: number): Observable<boolean> {
    /** Token will identify user */
    return this.authDelObs<boolean>(this.getTreeElementUrl(id.toString()));
  }

  updateComposant(composant: ArbreComposant): Observable<boolean> {
    return this.authPutObs<boolean>(
      this.getTreeElementRootUrl(),
      JSON.stringify(composant)
    );
  }
}
